// src/pages/usa/puertorico/Utuado.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Utuado ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Utuado() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Utuado, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Utuado, Puerto Rico</h2>

            <p>
              Utuado, located in the central mountainous region of Puerto Rico, is a
              hidden gem that offers a unique blend of natural beauty, rich history, and
              vibrant culture. Known for its landscapes, coffee plantations, and
              archaeological sites, Utuado provides a refreshing escape from the bustling
              coastal areas of the island. Visitors can explore the Caguana Indigenous
              Ceremonial Park, which showcases the ancient Taíno culture through its
              preserved ball courts and petroglyphs. The greenery and cool climate make
              it an ideal destination for hiking and nature walks, with trails leading to
              waterfalls, caves, lakes, and rivers.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Utuado is easily accessible by car from San Juan in about 1.5 to 2 hours via
              PR‑22 and PR‑10. The roads are generally well‑maintained and the drive
              offers scenic views of the island’s interior. It can also be reached from
              Aguadilla in about 1.5 hours via PR‑2 and PR‑10.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Arch Cave (Cueva del Arco):</strong> Cueva del Arco, also known
                  as the Arch Cave, is a breathtaking natural formation in the Tanamá
                  River cave system. It is renowned for its dramatic limestone arch and is
                  typically accessed via guided tours that include hiking and river
                  trekking. Even though I hiked to the cave, I think it is better to take
                  a guided tour for safety and to fully appreciate the geological and
                  historical significance of the site. Guides help with equipment, river
                  levels, weather, and what to expect during the tour.
                  <br />
                  <br />
                  <strong>Tour Operators:</strong>
                  <br />
                  🔗{" "}
                  <a
                    href="https://tanamariveradventures.com/tours"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tanamá River Adventures
                  </a>
                  <br />
                  🔗{" "}
                  <a
                    href="https://bateydelcemi.com/adventures/cave-tubing-tour/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Batey Zipline Adventure
                  </a>
                  <br />
                  🔗{" "}
                  <a
                    href="https://rinconvacations.com/tour/tanama-river-caving-tour/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rincón Vacations
                  </a>
                  <br />
                  🔗{" "}
                  <a
                    href="https://puertoricothingstodo.com/tanama-river-cueva-del-arco-adventure-tours/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Puerto Rico Things To Do
                  </a>
                  <br />
                  🔗{" "}
                  <a
                    href="https://www.puertoricodaytrips.com/tours/?l=utuado"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PR Day Trips
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.31564035876427,-66.77200803306745"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Parque Indígena Caguana:</strong> Parque Ceremonial Indígena de
                  Caguana is the most important Taíno archaeological site in the
                  Caribbean, with ancient ball courts, petroglyphs, and artifacts dating
                  back to around 1270 AD. The site features stone‑lined bateys, monoliths,
                  and carvings that tell the story of Taíno spirituality and daily life.
                  Surrounded by lush mountains, it is peaceful and culturally rich.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.295349679667513,-66.77826920468114"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Dos Bocas Dam and Lake:</strong> Lago Dos Bocas is a scenic
                  reservoir created by the Dos Bocas Dam on the Río Grande de Arecibo.
                  Mountains surround the lake, making it a tranquil setting for fishing,
                  boating, and enjoying local food. In the past there was a boat service
                  around the lake; at the time of writing, I couldn’t confirm if it is
                  still operating.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.33566748848189,-66.66748930692646"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems – Utuado</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Cañón Blanco (White Canyon):</strong> A striking limestone
                  canyon with bright white rock walls, part of the Tanamá River system.
                  Great for hiking, swimming, and photography, especially in early
                  morning light.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.22772325084133,-66.63984327928775"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Tanamá River Eco‑Adventures:</strong> Beyond Cueva del Arco, the
                  Tanamá River offers body rafting, cave tubing, cliff jumping, and jungle
                  hikes. Several local guides run eco‑adventure tours through this lush
                  valley.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.296195609847974,-66.78101592281472"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>El Mirador de Utuado:</strong> A scenic overlook with panoramic
                  views of the Utuado valley and surrounding mountains. Ideal for sunrise
                  or sunset photos and quiet reflection.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.270429034809606,-66.71569441706059"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Coffee Farm Visits:</strong> Utuado is part of Puerto Rico’s
                  coffee‑growing region. You can tour small fincas, learn about roasting,
                  and sample fresh coffee in the mountains.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.28810502446547,-66.76946560627543"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Café Gran Batey
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.309607826060333,-66.61940297049475"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Hacienda la Tradición
                  </a>
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay in Utuado</h3>

            <p>
              While I usually visit Utuado on day trips, here are some well‑rated spots if
              you plan to stay overnight. I try to keep this list accurate, but please
              double‑check with Expedia or Booking, as places may change over time.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Casa Grande Mountain Retreat:</strong> Adult‑only eco‑resort
                  surrounded by lush greenery. Offers a pool, yoga classes, and a café—a
                  peaceful mountain escape.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Utuado Lodging:</strong> Small, modern guesthouse in town with
                  clean rooms and personalized hospitality.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel Posada Jayuya:</strong> Comfortable hotel in nearby
                  Jayuya, with mountain views and on‑site restaurant.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Arecibo Inn:</strong> Relaxed inn about 30 minutes from Utuado,
                  with simple rooms, pool, breakfast, and a casual restaurant.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Finca Remedio:</strong> Eco‑farm stay offering rustic
                  accommodations, organic meals, and a focus on sustainable living.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Finca Sajorí:</strong> Scenic lodge with panoramic mountain
                  views, comfortable cabins, and hiking opportunities.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I took in Utuado. Set the quality to 1080p or higher
              for the best experience.
            </p>

            <p>
              <a
                href="https://youtu.be/Oi19kM_QgKI?si=OpuUDmspnMKaGlQt"
                target="_blank"
                rel="noopener noreferrer"
              >
                Dam Drive
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/4ljy8La16i8?si=MJcukGURPgv2UyYb"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cueva del Arco
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/Oi19kM_QgKI?si=OpuUDmspnMKaGlQt"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/utuado/DamandLake.JPG"
                alt="Dam and Lake Video"
              />
            </a>

            <a
              href="https://youtu.be/4ljy8La16i8?si=MJcukGURPgv2UyYb"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/utuado/CuevaArco.jpg"
                alt="Cueva del Arco Video"
              />
            </a>

            <img
              src="/images/usa/puertorico/utuado/CuevaDelArco.jpg"
              alt="Cueva del Arco"
            />
            <img
              src="/images/usa/puertorico/utuado/CaguandasPark.JPG"
              alt="Caguana Park"
            />
            <img
              src="/images/usa/puertorico/utuado/Caguanaspark2.JPG"
              alt="Caguana Park"
            />
            <img
              src="/images/usa/puertorico/utuado/Caguanaspark3.JPG"
              alt="Caguana Park"
            />
            <img
              src="/images/usa/puertorico/utuado/Iglesia.jpg"
              alt="Church in Utuado"
            />
            <img
              src="/images/usa/puertorico/utuado/Legislatura.jpg"
              alt="Alcaldía"
            />
            <img
              src="/images/usa/puertorico/utuado/Lake.JPG"
              alt="Lake in Utuado"
            />
            <img
              src="/images/usa/puertorico/utuado/PlantaHidroelectrica.JPG"
              alt="Hydroelectric Power Plant"
            />
            <img
              src="/images/usa/puertorico/utuado/Represadrone 2.jpg"
              alt="Dam Aerial View"
            />
            <img
              src="/images/usa/puertorico/utuado/Represadrone.jpg"
              alt="Dam Aerial View"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
